import { render, staticRenderFns } from "./RoundupsErrorTile.vue?vue&type=template&id=25926e1a&"
import script from "./RoundupsErrorTile.vue?vue&type=script&lang=js&"
export * from "./RoundupsErrorTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports